import { TElement, useEditorRef } from "@udecode/plate-common";

export const useIsInComment = (element: TElement) => {
  const editor = useEditorRef();
  return editor.id !== "main" && editor.id !== "nested";
};
